export default __webpack_public_path__ + "static/070-d19d88eee379b9398ca19b9b4371cb2f.jpg";